import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Divider,
  Autocomplete,
  FormHelperText,
  CircularProgress,
  createFilterOptions,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import subscriptionValidationSchema from ".././Validations/BannerValidation";

import { toast } from "react-toastify";
import {
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
  BUTTON_STYLES,
  FORM_STYLES,
} from "../../styles/componentStyles";
import api from "../../axiosInstance";
import FilterBar from "../Reusable/FilterBar";

function SubscriptionModal({ open, onClose, subscriptionEdit, onSuccess }) {
  const [universityList, setUniversityList] = useState([]);
  const [courseList, setCourseList] = useState([]);

  const [adminUsers, setAdminUsers] = useState([]);
  const [adminUsersPage, setAdminUsersPage] = useState(0);
  const [adminUsersTotalPages, setAdminUsersTotalPages] = useState(0);
  const [adminUsersQuery, setAdminUsersQuery] = useState("");
  const [selectedAdminUser, setSelectedAdminUser] = useState(null);
  const [adminUsersLoading, setAdminUsersLoading] = useState(false);
  const [selectedUniversityId, setSelectedUniversityId] = useState("");
  const [semesterList, setSemesterList] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  console.log(subscriptionEdit);
  const isEdit = subscriptionEdit && Object.keys(subscriptionEdit).length > 0;
  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      name: subscriptionEdit?.name || "",
      price: subscriptionEdit?.price || "",
      actualPrice: subscriptionEdit?.actualPrice || "",
      mentorshipSessions: subscriptionEdit?.mentorshipSessions || "",
      subjectsIncluded: subscriptionEdit?.subjectsIncluded || "",
      displayOrder: subscriptionEdit?.displayOrder || "",
      courseId: isEdit
        ? Array.isArray(subscriptionEdit.courseId)
          ? subscriptionEdit.courseId
          : [subscriptionEdit.courseId] // convert single number → array
        : [],
      deviceType: subscriptionEdit?.deviceType || "android",
      active: subscriptionEdit?.active || "true",
    },

    validationSchema: subscriptionValidationSchema.subscriptionValidationSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      try {
        let response;
        // If it's Edit data it will call Update api
        if (subscriptionEdit?.id) {
          response = await api.put(
            `/api/v1/subscriptions/${subscriptionEdit?.id}`,
            values
          );
        }
        // Else it's Add data it will call Add api
        else {
          console.log(values);
          response = await api.post("/api/v1/subscriptions", values);
        }
        // Show success toast
        toast.success(
          `Subscripptions ${
            subscriptionEdit?.id ? "updated" : "added"
          } successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          }
        );
        console.log(response.data.data[0]);

        onSuccess(response.data.data[0]);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      }
    },
  });
  //   All UniversityList Api Fetching
  useEffect(() => {
    api
      .get("/getAllUniversities")
      .then((res) => setUniversityList(res.data.data))
      .catch((err) => console.error(err));
  }, []);
  //   All UniversityList Api Fetching
  useEffect(() => {
    api
      .get(`/getCourses`, { params: { active: true } })
      .then((res) => {
        setCourseList(res.data.data);
      })
      .catch((err) => console.error(err));
  }, []);
  // Filter courses With University
  const filteredCourses = universityId
    ? courseList.filter((c) => c.universityId === universityId)
    : courseList;
  //   All Semesters Api Fetching
  // useEffect(() => {
  //   api
  //     .get(`/getSemesters`)
  //     .then((res) => {
  //       setSemesterList(res.data.data);
  //     })
  //     .catch((err) => console.error(err));
  // }, []);
  // Admin users: fetch function (paged, optional phone search)
  const fetchAdminUsers = async ({ page = 0, query = "" }) => {
    setAdminUsersLoading(true);
    try {
      const resp = await api.get("/api/v1/admin/users", {
        params: {
          page,
          size: 10,
          phone: adminUsersQuery || undefined,
        },
      });
      const content = resp.data?.content ?? [];
      const totalPages = resp.data?.totalPages ?? 0;
      setAdminUsers((prev) => (page === 0 ? content : [...prev, ...content]));
      setAdminUsersTotalPages(totalPages);
      setAdminUsersPage(page);
    } catch (e) {
      console.error(e);
    } finally {
      setAdminUsersLoading(false);
    }
  };

  // --- FETCH WHEN SEARCH INPUT CHANGES ---
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchAdminUsers(0, adminUsersQuery);
    }, 400); // debounce 400ms
    return () => clearTimeout(delay);
  }, [adminUsersQuery]);

  // --- HANDLE SCROLL TO BOTTOM (LOAD MORE) ---
  const handleUsersListboxScroll = (event) => {
    const listboxNode = event.currentTarget;
    if (
      listboxNode.scrollTop + listboxNode.clientHeight >=
      listboxNode.scrollHeight - 50
    ) {
      if (!adminUsersLoading && adminUsersPage + 1 < adminUsersTotalPages) {
        fetchAdminUsers(adminUsersPage + 1, adminUsersQuery);
      }
    }
  };

  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {subscriptionEdit && Object.keys(subscriptionEdit).length > 0
              ? "Update Subscriptions"
              : "Add Subscriptions"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              size="small"
              label="Name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              {...TEXT_FIELD_STYLES.standard}
              required
            />

            <TextField
              size="small"
              label="Price"
              name="price"
              value={formik.values.price}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.price && Boolean(formik.errors.price)}
              helperText={formik.touched.price && formik.errors.price}
              {...TEXT_FIELD_STYLES.standard}
            />
            <Box sx={FORM_STYLES.row}>
              <TextField
                size="small"
                label="Actual Price"
                name="actualPrice"
                value={formik.values.actualPrice}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actualPrice &&
                  Boolean(formik.errors.actualPrice)
                }
                helperText={
                  formik.touched.actualPrice && formik.errors.actualPrice
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
              <TextField
                size="small"
                label="Mentorship Sessions"
                name="mentorshipSessions"
                value={formik.values.mentorshipSessions}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.mentorshipSessions &&
                  Boolean(formik.errors.mentorshipSessions)
                }
                helperText={
                  formik.touched.mentorshipSessions &&
                  formik.errors.mentorshipSessions
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
            </Box>
            <Box sx={FORM_STYLES.row}>
              <TextField
                size="small"
                label="Subjects Included"
                name="subjectsIncluded"
                value={formik.values.subjectsIncluded}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.subjectsIncluded &&
                  Boolean(formik.errors.subjectsIncluded)
                }
                helperText={
                  formik.touched.subjectsIncluded &&
                  formik.errors.subjectsIncluded
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
              <TextField
                size="small"
                label="Display Order"
                name="displayOrder"
                value={formik.values.displayOrder}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.displayOrder &&
                  Boolean(formik.errors.displayOrder)
                }
                helperText={
                  formik.touched.displayOrder && formik.errors.displayOrder
                }
                {...TEXT_FIELD_STYLES.standard}
                sx={{
                  ...TEXT_FIELD_STYLES.standard.sx,
                  ...FORM_STYLES.field.sx,
                }}
              />
            </Box>
            <Box sx={FORM_STYLES.row} style={{ marginTop: "10px" }}>
              <FormControl fullWidth size="small">
                <InputLabel>Select University</InputLabel>
                <Select
                  value={universityId || ""}
                  onChange={(e) => {
                    setUniversityId(e.target.value);
                  }}
                  label="Select University"
                  sx={{
                    textAlign: "left",
                    backgroundColor: "#fff",
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {universityList.map((u) => (
                    <MenuItem key={u.id} value={u.id}>
                      {u.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
              >
                <Autocomplete
                  size="small"
                  name="Courses"
                  multiple
                  options={filteredCourses}
                  getOptionLabel={(option) => option.courseName || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                      {option.courseName}
                    </li>
                  )}
                  value={filteredCourses.filter((course) =>
                    (formik.values.courseId || []).includes(course.id)
                  )}
                  onChange={(event, newValue) => {
                    formik.setFieldValue(
                      "courseId",
                      newValue.map((course) => course.id)
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Courses"
                      placeholder="Search & Select Courses"
                    />
                  )}
                />

                {formik.touched.courseId && formik.errors.courseId && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.courseId}
                  </FormHelperText>
                )}
              </FormControl>

              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
                size="small"
              >
                <InputLabel>Device Type</InputLabel>
                <Select
                  label="Device Type"
                  name="deviceType"
                  value={formik.values.deviceType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.deviceType &&
                    Boolean(formik.errors.deviceType)
                  }
                >
                  <MenuItem value="android">Android</MenuItem>
                  <MenuItem value="ios">Ios</MenuItem>
                </Select>
                {formik.touched.deviceType && formik.errors.deviceType && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.deviceType}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl
                {...TEXT_FIELD_STYLES.standard}
                sx={FORM_STYLES.field.sx}
                size="small"
              >
                <InputLabel>Active</InputLabel>
                <Select
                  label="Active"
                  name="active"
                  value={formik.values.active}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.active && Boolean(formik.errors.active)}
                >
                  <MenuItem value="true">Yes</MenuItem>
                  <MenuItem value="false">No</MenuItem>
                </Select>
                {formik.touched.active && formik.errors.active && (
                  <FormHelperText sx={{ color: "#d9322f" }}>
                    {formik.errors.active}
                  </FormHelperText>
                )}
              </FormControl>
            </Box>
          </Box>

          <Box
            sx={FORM_STYLES.actions}
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
              Cancel
            </Button>
            <Button type="submit" {...BUTTON_STYLES.primary}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default SubscriptionModal;
